<script>
import { healthRecordService } from '@services/safehaven/HealthRecordService'
export default {
  created() {
    localStorage.clear()
  },
  mounted() {
    this.validateUrl()
  },

  methods: {
    async validateUrl() {
      try {
        const obj = {
          uid: this.$route?.path.split('/')[3],
          token: this.$route?.path.split('/')[4],
        }
        localStorage.setItem('emailTokenDetails', JSON.stringify(obj))
        const responseData = await healthRecordService.vaidateUrl(obj)
        if (responseData) {
          if (responseData.data.has_revoked) {
            this.$router.push({
              name: 'share-health-record-link-revoked',
              params: { base: 'health-record' },
            })
          } else if (responseData.data.has_expired) {
            this.$router.push({
              name: 'share-record-link-expired',
              params: { base: 'health-record' },
            })
          } else {
            this.$router.push({
              name: 'recipient-verification',
              params: { recipientData: responseData.data },
            })
          }
        } else {
          // console.log(responseData)
          this.$router.push({
            name: 'share-record-link-expired',
          })
        }
      } catch (error) {
        console.warn(error)
        this.$router.push({
          name: 'share-record-link-expired',
        })
      }
    },
  },
}
</script>

<template>
  <v-progress-circular
    :size="150"
    :class="$style.loader"
    color="primary"
    indeterminate
  ></v-progress-circular>
</template>

<style lang="scss" module>
@import '@design';

.loader {
  display: flex;
  margin: auto;
  margin-top: 30vh;
}
</style>
